import PropTypes from 'prop-types'

import leadObjectType from './lead-prop-type'
import treatmentQuotationObjectType from './treatment-quotation-obj-type'

export default PropTypes.shape({
    id: PropTypes.string,
    freshDeskId: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    gender: PropTypes.string,
    companyCode: PropTypes.string,
    brand: PropTypes.string,
    dob: PropTypes.string,
    referenceNumber: PropTypes.string,
    streetAddress: PropTypes.string,
    streetAddressExtension: PropTypes.string,
    street: PropTypes.string,
    houseNumber: PropTypes.string,
    zip: PropTypes.string,
    city: PropTypes.string,
    staircase: PropTypes.string,
    door: PropTypes.string,
    solvencyCheckFailed: PropTypes.bool,
    countryCode: PropTypes.string,
    treatmentExpectation: PropTypes.object,
    medicalCondition: PropTypes.object,
    physician: PropTypes.string,
    googleClientId: PropTypes.string,
    upperTraySize: PropTypes.string,
    lowerTraySize: PropTypes.string,
    store: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    emailVerified: PropTypes.bool,
    imagesUploaded: PropTypes.bool,
    wantsRatePay: PropTypes.bool,
    vip: PropTypes.bool,
    inEscalation: PropTypes.bool,
    activeTreatmentQuotation: PropTypes.number,
    activeTreatmentPlan: PropTypes.number,
    retainerCheckoutActive: PropTypes.bool,
    firstRetainerFree: PropTypes.bool,
    purchaseEstimation: PropTypes.string,
    leadList: PropTypes.array,
    processList: PropTypes.array,
    feedbackList: PropTypes.array,
    created: PropTypes.string,
    leadId: PropTypes.string,
    prospectId: PropTypes.string,
    stripeCustomerId: PropTypes.string,
    physicianId: PropTypes.string,
    partnerPhysicianId: PropTypes.string,
    partnerSupplierId: PropTypes.string,
    partnerTreatmentPlanerId: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    doubleOptInId: PropTypes.string,
    treatingPhysicianId: PropTypes.string,
    changedByUserId: PropTypes.string,
    createdByUserId: PropTypes.string,
    socialSecurityNumber: PropTypes.string,
    dataTransferDS: PropTypes.bool,
    drSmileTransfer: PropTypes.bool,

    // Rich props
    lead: leadObjectType,
    prospect: PropTypes.object,
    stripeCustomer: PropTypes.object,
    physicianObject: PropTypes.object,
    partnerPhysician: PropTypes.object,
    partnerSupplier: PropTypes.object,
    partnerTreatmentPlaner: PropTypes.object,
    doubleOptIn: PropTypes.object,
    treatingPhysician: PropTypes.object,
    changedByUser: PropTypes.object,
    createdByUser: PropTypes.object,

    // Arrays
    treatmentPlanList: PropTypes.array,
    treatmentQuotationList: PropTypes.arrayOf(treatmentQuotationObjectType),
    treatmentExecutionList: PropTypes.array,
    shipmentList: PropTypes.array,
    salesOrderList: PropTypes.array,
    invoiceList: PropTypes.array,
    paymentList: PropTypes.array,
    appointmentList: PropTypes.array,
    imageList: PropTypes.array,
    scanFileList: PropTypes.array,
    treatmentPlanFileList: PropTypes.array,
    treatmentPlanExternalFileList: PropTypes.array,
    productionFileList: PropTypes.array,
})



// WEBPACK FOOTER //
// ./src/prop-types/customer-obj-type.js